import { Maybe, ObjectType } from '@csp/csp-common-model';
import { ElaasEventConfig } from '@csp/csp-common-rpm-model';
import joi from 'joi';
import { RpmEventConfigV1 } from '../meta/RpmEventConfigV1';
import { RPM_EVENT_V1_META_NAME, RpmEventMetaV1 } from '../meta/RpmEventMetaV1';

const elaasEventConfigSchema = joi
  .object({
    algorithms: joi
      .array()
      .items(
        joi.object({
          algorithmCode: joi.string().required(),
          versionCode: joi.string().required(),
        }),
      )
      .required(),
    aggregated: joi.array().items(
      joi.object({
        identifier: joi.string().required(),
        formulas: joi
          .array()
          .items(
            joi.object({
              algorithmCode: joi.string().required(),
              versionCode: joi.string().required(),
            }),
          )
          .required(),
        consequences: joi
          .array()
          .items(
            joi.object({
              consequenceCode: joi.string().required(),
              versionCode: joi.string().required(),
              includeWhen: joi
                .alternatives(
                  joi.object({ operator: joi.string().required(), criteria: joi.array().required() }),
                  joi.object({
                    identifier: joi.string().required(),
                    type: joi.string(),
                    outcomes: joi.array().items(joi.string()).required(),
                  }),
                )
                .required(),
            }),
          )
          .required(),
      }),
    ),
  })
  .options({ allowUnknown: true });

const getRpmEventConfigFromMeta = (config: unknown): ElaasEventConfig => {
  const elaasEventConfig = config as RpmEventConfigV1;
  joi.assert(config, elaasEventConfigSchema);
  return elaasEventConfig;
};

const fromRpmEventConfigMetaV1 = (meta: RpmEventMetaV1 | Maybe<ObjectType>): Maybe<ElaasEventConfig> => {
  const configV1 = meta?.[RPM_EVENT_V1_META_NAME];
  return configV1 ? getRpmEventConfigFromMeta(configV1) : undefined;
};

export const RpmEventConfigMapper = { fromRpmEventConfigMetaV1 };
